// Force-Build: 2
import appStarterFactory from 'bundles/page/lib/appStarterFactory';
import appEnv from 'bundles/video-logged-out-page/appEnv';

export default appStarterFactory(appEnv);
